/**
 * Marks a browser tab that left for Meta's dialog from AdBlaster ›
 * Partnerships › Manage › Connect with Facebook. A cancelled login comes back
 * to /authenticate-connector without a code, and the marker is how that page
 * knows to return to Partnerships rather than report a connector failure.
 */
const AGENCY_LOGIN_MARKER_KEY = "partnerships:agency-login-started"
/** The API's nonce lives 10 minutes; an older marker is a login abandoned elsewhere. */
const AGENCY_LOGIN_MARKER_TTL_MS = 10 * 60 * 1000

function hasSessionStorage() {
  return typeof window !== "undefined" && typeof sessionStorage !== "undefined"
}

export function markAgencyLoginStarted(): void {
  if (!hasSessionStorage()) return
  sessionStorage.setItem(AGENCY_LOGIN_MARKER_KEY, Date.now().toString())
}

/** Whether this tab started an agency login within the last 10 minutes; spends the marker. */
export function takeAgencyLoginMarker(): boolean {
  if (!hasSessionStorage()) return false
  const startedAt = Number(sessionStorage.getItem(AGENCY_LOGIN_MARKER_KEY))
  sessionStorage.removeItem(AGENCY_LOGIN_MARKER_KEY)
  return startedAt > 0 && Date.now() - startedAt < AGENCY_LOGIN_MARKER_TTL_MS
}
